export const goldGlow = {
	shadowColor: '#FF7200',
	shadowOffset: { width: 0, height: 0 },
	shadowOpacity: 0.5,
	shadowRadius: 30,
	elevation: 12,
} as const;

// Figma card treatment: a red inner rim with a soft orange bloom.
export const vipCardGlow = {
	boxShadow: 'inset 0 0 10px #ff0000, 0 0 10px #ff7200',
} as const;
